import { Navigate as RouterNavigate } from 'react-router-dom'

const Navigate = ({ state = {}, withCanGoBack = false, ...rest }) => {
  const finalState = withCanGoBack ? { ...state, canGoBack: true } : state

  return <RouterNavigate {...rest} state={finalState} />
}

export default Navigate
